import { getProductIdFromProductCode } from '@noths/polaris-client-utils';

import type { Product } from 'src/redux/products/types/Product';
import { logger } from 'src/utils/serverLogger';

export const transformProductsToGAReturnedProductsArray = (products: Product[]) => {
  return products
    .map(({ code }) => {
      const productId = code ? getProductIdFromProductCode(code) : null;

      if (!code) {
        logger.warn(
          `Product code is undefined or null in transformProductsToGAReturnedProductsArray`,
        );
      }

      return {
        product: {
          id: String(productId),
        },
      };
    })
    .filter(Boolean);
};
